// Change this to your firebase configuration! (Add Firebase to your web app)
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET
};
